import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class FundService {

    static getMyFundTransfers(item) {

        let api = `${API_BASE_URL}${API_PATHS.getMyFundTransfers}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.usertype) params.append("usertype", item.usertype);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static getReferralIncome(item) {

        let api = `${API_BASE_URL}${API_PATHS.getReferralIncome}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static getAutoPoolIncome(item) {

        let api = `${API_BASE_URL}${API_PATHS.getAutoPoolIncome}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static getMySupportIncome(item) {

        let api = `${API_BASE_URL}${API_PATHS.getMySupportIncome}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static transferFund(item) {

        let api = `${API_BASE_URL}${API_PATHS.transferFund}`;



        return axiosInstance.post(api, item);
    }

    static getMyWithdrawals(item) {

        let api = `${API_BASE_URL}${API_PATHS.getMyWithdrawals}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static createWithdrawalRequest(item) {

        let api = `${API_BASE_URL}${API_PATHS.createWithdrawalRequest}`;
        return axiosInstance.post(api, item);
    }


    static getUserDetailsByUserId(item) {

        let api = `${API_BASE_URL}${API_PATHS.getUserDetailsByUserId}`;

        const params = new URLSearchParams();

        if (item?.userId) params.append("userId", item.userId);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

}

export default FundService;
